import { createSlice } from '@reduxjs/toolkit';
import {sampleColors} from "../../utils/colors";



export const DefaultPortfolioPathIds = [
    '8d29e13e-cb60-4364-a37a-3aa43b7f3c43',
    '2c526be1-86fb-486b-aff9-76a65c53ef7d',
    '42d31e88-c7a8-462c-ae50-09a2e2599015',
    '93c6b886-cea8-4c81-b7a7-6d91ae2cc763',
    'be9db8ce-41a4-4e71-833c-c14f0e0323bd',
    '51d67586-b435-4060-b0a7-2f382e3f6fda',
    '68d24aaa-00e4-487c-bbdc-c288636bbfdb',
    '7e35f135-3777-4c82-8c4f-9677a88930c1'
];

const initialState = {

    siderVisible: true,

    selectedAppdataIds: {
        blacklist: null,
        screen: null,
    },
    etfColors: {},
    chartSeries: null,
    selectedPortfolio: null,

    comparison: {
        _maxTickers: 9,
        colors: {}
    },
    etfMatrix: {
        etfList: [],
        positionTableMode: 'trunc',

    },
    portfolioPathIds: DefaultPortfolioPathIds

};

const appStatesSlice = createSlice({
  name: 'appStates',
  initialState,
  reducers: {


      toggleSider(state) {
        state.siderVisible = !state.siderVisible;
      },

      setEtfColors(state, action) {
        state.etfColors[action.payload.id] = action.payload.color;
      },


      /* ETF Matrix App State Config */

      updateEtfMatrixConfig(state, action) {
        state.etfMatrix = {
            ...state.etfMatrix,
            ...action.payload
        }
      },     // New Reducer to create a new ETF matrix
       // New Reducer to create a new ETF matrix
        createNewEtfMatrix(state, action) {
            state.etfMatrix.etfList = [...action.payload]; // Resetting etfList to new array of symbols
        },

        // Reducer to add an ETF to the matrix
        addEtfToMatrix(state, action) {
            if (!state.etfMatrix.etfList.includes(action.payload)) {
                state.etfMatrix.etfList.push(action.payload); // Adds the ticker if it’s not already in the list
            }
        },

        // Reducer to remove an ETF from the matrix
        removeEtfFromMatrix(state, action) {
            state.etfMatrix.etfList = state.etfMatrix.etfList.filter(
                ticker => ticker !== action.payload // Filters out the ticker symbol to remove it
            );
        },

      setPortfolioPathIds(state, action) {
        state.portfolioPathIds = action.payload;
      }



  },
});

export const {
    setEtfColors,
    updateEtfMatrixConfig,
    toggleSider,
    setPortfolioPathIds,
    createNewEtfMatrix,
    addEtfToMatrix,
    removeEtfFromMatrix
} = appStatesSlice.actions;



export default appStatesSlice.reducer;





